// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/QuestionCard.tsx (L236-L267 FreeTextRow)
import type { ComponentType } from 'react';

import { MAX_SHORT_TEXT_LENGTH } from '@/contracts/onboarding-session';

export interface FreeTextRowProps {
  label: string;
  icon?: ComponentType<{ className?: string }>;
  value: string;
  onChange: (value: string) => void;
  /** Enter: send the answer (a single or multi question) or add a chip (a rank question). */
  onSubmit: () => void;
}

/**
 * The "Somewhere else…" row: an input in place, under the options. Enter submits (no button inside the row, as
 * in TP). Ours: `maxLength` is the BFF's short-text limit, and a plain Enter only: Cmd/Ctrl+Enter is the card's
 * Next shortcut and passes through to it.
 */
export function FreeTextRow({ label, icon: Icon, value, onChange, onSubmit }: FreeTextRowProps) {
  return (
    <div className="flex min-h-9 items-center gap-2.5 rounded-md border border-ds-hairline px-2 py-1 focus-within:border-ds-focus">
      {Icon ? (
        <span aria-hidden="true" className="flex size-6 shrink-0 items-center justify-center rounded-sm bg-ds-ink-a05 text-ds-text-2">
          <Icon className="size-3.5" />
        </span>
      ) : null}
      <input
        value={value}
        maxLength={MAX_SHORT_TEXT_LENGTH}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== 'Enter' || e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.nativeEvent.isComposing) return;
          e.preventDefault();
          onSubmit();
        }}
        placeholder={label}
        aria-label={label}
        // The DS draws a 2px outline on every :focus-visible (specificity above `outline-none`): the row's own border is the focus mark.
        className="min-w-0 flex-1 bg-transparent text-body-sm text-foreground outline-none placeholder:text-ds-text-3 focus-visible:!outline-none"
      />
    </div>
  );
}
